import { CSSObject } from '@emotion/react';

export const ButtonIncrease: CSSObject = {
  h: '10',
  variant: 'solid',
  fontFamily: 'accent',
  fontWeight: 'normal',
  color: 'alpha.600',
  textShadow: '0px 1px 0px rgba(255, 255, 255, 0.30)',
  borderRadius: 'md',
  bg: 'beta.400',
  boxShadow:
    '0px -3px 4px 0px rgba(0, 0, 0, 0.20) inset, 0px 4px 4px 0px rgba(255, 255, 255, 0.15) inset, 0px 4px 8px 0px rgba(0, 0, 0, 0.20), 0px 1px 0px 0px rgba(255, 255, 255, 0.30) inset',
  _hover: {
    color: 'alpha.800',
    bg: 'beta.600',
  },
};

export const buttonIncreaseProps: CSSObject = {
  paddingLeft: '8px',
  paddingRight: '8px',
  fontSize: ['11px', '11px', 'sm'],
};
